import { Action } from '@reduxjs/toolkit';
import { Epic, combineEpics } from 'redux-observable';
import { filter, ignoreElements, tap, withLatestFrom } from 'rxjs';

import module from './index';

import { RootState } from 'store/wos_store';

const { actions, selectors } = module;

const hideBrandingEpic: Epic<Action, Action, RootState> = (action$, state$) =>
  action$.pipe(
    filter(actions.toggleHideBranding.match),
    withLatestFrom(state$),
    tap(([, state]) => {
      const hide = selectors.hideBranding(state);
      window.localStorage.setItem('hideBranding', hide.toString());
    }),
    ignoreElements()
  );

const showFilenamesEpic: Epic<Action, Action, RootState> = (action$, state$) =>
  action$.pipe(
    filter(actions.toggleShowFilenames.match),
    withLatestFrom(state$),
    tap(([, state]) => {
      const show = selectors.showFilenames(state);
      window.localStorage.setItem('showFilenames', show.toString());
    }),
    ignoreElements()
  );

const themeEpic: Epic<Action, Action, RootState> = (action$, state$) =>
  action$.pipe(
    filter(actions.toggleTheme.match),
    withLatestFrom(state$),
    tap(([, state]) => {
      const theme = selectors.theme(state);
      window.localStorage.setItem('theme', theme);
    }),
    ignoreElements()
  );

const combined = combineEpics(hideBrandingEpic, showFilenamesEpic, themeEpic);

export default combined;
